import { Directive, Input, ElementRef, AfterViewInit, HostListener, Renderer2 } from '@angular/core';
import { Utility } from '../_service/utility';

@Directive({
  selector: '[appDropdownAutoLocate]',
})
export class DropdownAutoLocateDirective implements AfterViewInit {
  @Input()
  menuWidth;

  @Input()
  dropdownWidth;


  @Input()
  rect;
  windowWidth;

  @HostListener('window:resize', ['$event'])
  onResize(event) {
    this.windowWidth = this._utility.getWindow().innerWidth;
  }

  constructor(
    private elementRef: ElementRef,
    private renderer: Renderer2,
    private _utility:Utility
  ) {
  }

  ngAfterViewInit() {
    this.windowWidth = this._utility.getWindow().innerWidth;
    const hostElem = this.elementRef.nativeElement;
    const _menuWidth = this.menuWidth;
    const _menuLeft = hostElem.parentNode.getBoundingClientRect().left;
    // const _menuLeft = hostElem.parentNode.parentNode.parentNode.getElementsByClassName("d-block").getBoundingClientRect().left;
    const _dropdownWidth = this.dropdownWidth;
    const _windowWidth = this.windowWidth;
    // console.log(_menuLeft);
    let dropdownLeft = (_menuWidth / 2) - (_dropdownWidth / 2);
    let dropdownRight = dropdownLeft + _dropdownWidth;

    if (_menuLeft + (_menuWidth / 2) + (_dropdownWidth / 2) > (_windowWidth - 10 )) {
      // let diff = _menuLeft + (_menuWidth / 2) + (_dropdownWidth / 2) - (_windowWidth - 10) + dropdownLeft;
      // dropdownLeft = dropdownLeft - diff;
    }
    if(!!this.rect && !!this.rect.left)
    {
      dropdownLeft+= parseInt(this.rect.left +"");
    }

    this.renderer.setStyle(hostElem, 'left', dropdownLeft + 'px');
    this.renderer.setStyle(hostElem, 'width', _dropdownWidth + 'px');
    this.renderer.setStyle(hostElem, 'max-width', _dropdownWidth + 'px');
  }
}
